import type { SilaeCredentialSchema } from '@libs/data-access/entities'
import { appQueryClient } from '@libs/data-access/queries'
import { useMutation } from '@tanstack/react-query'

import type {
  NewApiErrorResponse,
  UseAppMutationOptions
} from '../../../../types'
import type { PutSilaeCredentialOption } from '../silae.credentials.api'
import { putSilaeCredential } from '../silae.credentials.api'
import { silaeCredentialsCacheKeys } from '../silae.credentials.cacheKeys'

export const usePutSilaeCredential = (
  mutationOptions?: UseAppMutationOptions<
    SilaeCredentialSchema,
    NewApiErrorResponse,
    PutSilaeCredentialOption
  >
) => {
  return useMutation<
    SilaeCredentialSchema,
    NewApiErrorResponse,
    PutSilaeCredentialOption
  >({
    ...mutationOptions,
    mutationKey: silaeCredentialsCacheKeys.put_silae_credentials(),
    mutationFn: opts => putSilaeCredential(opts),
    onSuccess: (...args) => {
      mutationOptions?.onSuccess?.(...args)
      appQueryClient.invalidateQueries({
        queryKey: silaeCredentialsCacheKeys.get_silae_credentials()
      })
    }
  })
}
